define('shoptheme/components/ui/affix',[
	"jquery",
	"cartware/components/_base",
	"cartware/jquery/bem"
], function(
	$,
	Component,
	BEM
) {

	return Component.create({

		blocks: null,

		$init: function() {
			var affixTop;

			this.blocks = BEM.block('category-view');
			this.blocks.each(function() {
				var block = BEM.block(this);
				var container = block.getElements('headline-affix-padding');
				var headline = block.getElements('headline');

				if (container.length > 0) {
					affixTop = container.offset().top;
					headline.attr('data-offset-top', affixTop);

					$(window).off('.affix')
					headline.removeData('affix').removeClass('affix affix-top affix-bottom')
					headline.affix({ offset: affixTop})
					container.css('height', container.outerHeight(true));

				}

			});

		}

	});

});
